import React, { useEffect, useState } from "react";
import axios from "axios";
import { commonUrl, redirectUrl } from "src/config";
import { useNavigate } from "react-router";
import dayjs from "dayjs";
import { Button } from "@mui/material";
import PropTypes from "prop-types";

const receipt = {
  width: "302px",
  margin: "0 auto",
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: "13px",
  fontWeight: "400",
  lineHeight: "1.6",
  color: "#000",
  backgroundColor: "#fff",
  padding: "10px 8px",
};

const center = { textAlign: "center" };
const bold = { fontWeight: "bold" };
const small = { fontSize: "12px" };

const Divider = ({ dashed = true }) => (
  <div
    style={{
      borderTop: dashed ? "1px dashed #000" : "1px solid #000",
      margin: "6px 0",
    }}
  />
);

Divider.propTypes = { dashed: PropTypes.bool };

const PrintOneThroughProps = ({ state, componentRef, handlePrint }) => {
  const navigate = useNavigate();
  const [company, setCompany] = useState(null);
  const [logo, setLogo] = useState(null);
  const { header, table, type } = state || {};

  const hasOutsource = (table || []).some(
    (item) =>
      item.item?.toLowerCase().includes("outsource") ||
      item.item?.toLowerCase().includes("carpet")
  );

  useEffect(() => {
    axios
      .get(commonUrl + "main/getCompanyDetails", { withCredentials: true })
      .then((res) => {
        if (res.data[0]) {
          setCompany(res.data[0]);
          if (res.data[0]?.logo) {
            setLogo(JSON.parse(res.data[0].logo)?.img);
          }
        }
      })
      .catch((err) => {
        if (err.response?.status === 401 || err.response?.status === 403)
          window.location.href = redirectUrl;
      });
  }, []);

  const totalQty = (table || []).reduce((acc, r) => acc + (r.qty || 0), 0);

  // Shorten type names for print
  const shortType = (t) => {
    if (!t) return "-";
    const upper = t.toUpperCase();
    if (upper === "WASH & PRESS") return "W/P";
    if (upper === "DRY CLEAN") return "D/C";
    if (upper === "WASH") return "W";
    if (upper === "PRESS") return "P";
    return t;
  };

  const laundryOpts = header?.laundryStatus ? header.laundryStatus.split(",") : [];
  const topOpts = laundryOpts.filter(opt => !opt.includes("PERFUME") && !opt.includes("NISHA"));
  const noteOpts = laundryOpts.filter(opt => opt.includes("PERFUME") || opt.includes("NISHA"));

  return (
    <>
      {/* PRINT CSS */}
      <style>{`
        @media print {
          @page { 
            size: 80mm auto; 
            margin: 0mm; 
          }

          body {
            margin: 0;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          body * {
            visibility: hidden;
          }

          #thermal-receipt,
          #thermal-receipt * {
            visibility: visible;
          }

          #thermal-receipt {
            position: absolute;
            left: 0;
            top: 0;
            width: 302px;
            padding: 10px 8px;
          }

          .no-print {
            display: none !important;
          }
        }
      `}</style>

      {/* BUTTONS */}
      <div
        className="no-print"
        style={{ padding: "12px", marginBottom: "8px" }}
      >
        <Button variant="contained" onClick={handlePrint} autoFocus>
          Print
        </Button>
        <Button style={{ marginLeft: "10px" }} onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>


      {/* RECEIPT */}
      <div id="thermal-receipt" ref={componentRef} style={receipt}>

        {/* ===== TOP 3 LINES: STATUS / DATE / INVOICE NO ===== */}
        {topOpts.length > 0 && (
          <>
            <div
              style={{
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "20px",
                letterSpacing: "2px",
                padding: "4px 0",
              }}
            >
              {topOpts.join(", ").toUpperCase()}
            </div>

            <div style={{ borderTop: "1px solid #000", margin: "4px 0" }} />
          </>
        )}



        <div
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "18px",
            padding: "4px 0",
          }}
        >
          {header?.deliveryDate
            ? dayjs(header.deliveryDate).format("DD/MM/YYYY hh:mm A")
            : "-"}
        </div>

        <div style={{ borderTop: "1px solid #000", margin: "4px 0" }} />

        <div style={{ textAlign: "center", margin: "4px 0" }}>
          <div
            style={{
              display: "inline-block",
              fontWeight: "bold",
              fontSize: "18px",
              padding: "4px 12px",
              backgroundColor: "#000",
              color: "#fff",
              letterSpacing: "1px",
              borderRadius: "2px"
            }}
          >
            #{header?.billNo || "-"}
          </div>
        </div>

        <div style={{ borderTop: "1px solid #000", margin: "4px 0" }} />

        {/* COMBINED NOTES (NOTE, PERFUME, NISHA) */}
        {(header?.note || noteOpts.length > 0) && (
          <>
            <div
              style={{
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "16px",
                padding: "4px 0",
              }}
            >
              {[noteOpts.join(", ").toUpperCase(), header?.note].filter(Boolean).join(" - ")}
            </div>
            <div style={{ borderTop: "1px solid #000", margin: "4px 0" }} />
          </>
        )}

        {/* LOGO */}
        {logo && (
          <div style={{ ...center, margin: "6px 0" }}>
            <img src={logo} alt="logo" style={{ width: "200px" }} />
          </div>
        )}

        {/* COMPANY */}
        <div style={{ ...center, ...bold }}>
          {company?.Name}
        </div>
        {company?.Ph && (
          <div style={{ ...center, ...small }}>Ph: {company?.Ph}</div>
        )}
        <div style={{ ...center, ...small }}>
          {company?.additional_no}
        </div>
        <div style={{ ...center, ...bold }}>
          {company?.license_no}
        </div>
        {/* {company?.Add2 && (
          <div style={{ ...center, ...small }}>{company?.Add2}</div>
        )} */}
        {/* {company?.Ph && (
          <div style={{ ...center, ...small }}>Ph: {company?.Ph}</div>
        )} */}

        <Divider dashed={false} />

        {/* TRANSACTION INFO */}
        <div style={small}>
          <div>Cashier      : {header?.staff?.label || header?.staff || "-"}</div>
          <div>Payment Type : {header?.paymentMode || "Cash"}</div>
          <div style={{ fontWeight: "bold" }}>
            Issue Date: {header?.billDate || dayjs(header?.date).format("DD/MM/YYYY")}{header?.billTime ? ` ${header.billTime}` : ""}
          </div>

          {(header?.party?.label || header?.party?.name || header?.name) && (
            <div>Name : {header?.party?.label || header?.party?.name || header?.name}</div>
          )}
          {header?.party?.phone && (
            <div>Phone : {header.party.phone}</div>
          )}
          {header?.party?.address && (
            <div>Address : {header.party.address}</div>
          )}
        </div>

        <Divider />

        {/* TABLE */}
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "12px",
          }}
        >
          <thead>
            <tr style={{ borderBottom: "1px dashed #000" }}>
              <th style={{ textAlign: "left", width: hasOutsource ? "60%" : "45%" }}>Item</th>
              <th style={{ textAlign: "left", width: hasOutsource ? "0%" : "15%", display: hasOutsource ? "none" : "table-cell" }}>Type</th>
              <th style={{ textAlign: "center", width: "10%" }}>Qty</th>
              <th style={{ textAlign: "right", width: "15%" }}>Price</th>
              <th style={{ textAlign: "right", width: "15%" }}>Total</th>
            </tr>
          </thead>

          <tbody>
            {(table || []).map((item, idx) => {
              const isHighlighted = item.sqft == 1 || item.sqft === "1";
              const isOutsource = item.item?.toLowerCase().includes("outsource") || item.item?.toLowerCase().includes("carpet");
              const displayQty = isOutsource && item.sqft ? `${item.sqft} m²` : item.qty;
              const displayType = isOutsource ? "" : shortType(item.type);
              return (
                <React.Fragment key={idx}>
                  <tr style={{
                    borderBottom: "1px dotted #eee",
                    ...(isHighlighted ? {
                      backgroundColor: "#000",
                      color: "#fff",
                      letterSpacing: "1px"
                    } : {})
                  }}>
                    <td style={{ paddingTop: "4px", paddingBottom: "4px", fontWeight: "bold", paddingLeft: isHighlighted ? "4px" : "0" }}>
                      {item.item}
                      {header?.laundry_variant && item.variant && (
                        <span style={{ fontSize: "10px", fontWeight: "normal", color: isHighlighted ? "#ccc" : "#555", marginLeft: "6px" }}>
                          ({item.variant})
                        </span>
                      )}
                    </td>
                    <td style={{
                      paddingTop: "4px",
                      paddingBottom: "4px",
                      textAlign: "left",
                      fontWeight: "bold",
                      fontSize: "11px",
                      display: hasOutsource ? "none" : "table-cell"
                    }}>{displayType}</td>
                    <td style={{ paddingTop: "4px", paddingBottom: "4px", textAlign: "center" }}>{displayQty}</td>
                    <td style={{ paddingTop: "4px", paddingBottom: "4px", textAlign: "right" }}>
                      {Number(item.rate || 0).toFixed(2)}
                    </td>
                    <td style={{ paddingTop: "4px", paddingBottom: "4px", textAlign: "right", paddingRight: isHighlighted ? "4px" : "0" }}>
                      {Number(item.total || 0).toFixed(2)}
                    </td>
                  </tr>
                </React.Fragment>
              )
            })}
          </tbody>
        </table>

        <Divider />

        {/* SUMMARY */}
        <div style={{ display: "flex", justifyContent: "space-between", ...small }}>
          <span>Pieces</span>
          <span>
            {(table || []).reduce((a, b) => a + (b.qty || 0), 0)}
          </span>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", ...small }}>
          <span>Total</span>
          <span>{Number(header?.total || 0).toFixed(2)}</span>
        </div>

        {((header?.discPerc || 0) > 0 || (header?.discAmt || 0) > 0 || (header?.discPercAmt || 0) > 0) && (
          <div style={{ display: "flex", justifyContent: "space-between", ...small }}>
            <span>Discount {header?.discPerc > 0 ? `(${header.discPerc}%)` : ""}</span>
            <span>-{Number((header?.discPercAmt || 0) + (header?.discAmt || 0)).toFixed(2)}</span>
          </div>
        )}

        <Divider />

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          <span>Grand Total</span>
          <span>{Number(header?.netTotal || 0).toFixed(2)}</span>
        </div>

        {header?.print_outstanding_balance !== false && header?.balance !== undefined && header?.balance !== null && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: "14px",
              fontWeight: "bold",
              marginTop: "4px",
              borderTop: "1px dashed #000",
              paddingTop: "4px"
            }}
          >
            <span>Outstanding Balance</span>
            <span>{Number(header.balance).toFixed(2)}</span>
          </div>
        )}

        <Divider dashed={false} />

        {/* FOOTER */}
        <div style={{ ...center, ...small, marginTop: "6px" }}>
          <div style={bold}>Thanks for your Visit</div>
        </div>

        <div style={{ height: "20px" }} />
      </div>
    </>
  );
};

export default PrintOneThroughProps;

PrintOneThroughProps.propTypes = {
  state: PropTypes.any,
  componentRef: PropTypes.any,
  handlePrint: PropTypes.any,
};

// import React, { useEffect,  useState } from "react";

// import axios from "axios";
// import { commonUrl, redirectUrl } from "src/config";
// import {  useNavigate } from "react-router";
// import dayjs from "dayjs";
// import { Button } from "@mui/material";
// import PropTypes from "prop-types";

// const PrintOneThroughProps = ({state,componentRef,handlePrint}) => {
//   // const location = useLocation();
//   const navigate = useNavigate();
//   const [company, setCompany] = useState(null);
//   const [logo, setLogo] = useState(null);
//   const { header, table, type } = state || {};

//   useEffect(() => {
//     function getStatusDatas() {
//       axios
//         .get(commonUrl + "main/getCompanyDetails", { withCredentials: true })
//         .then((res) => {
//           if (res.data[0]) {
//             setCompany(res?.data[0]);
//             if (res?.data[0]?.logo) {
//               const parseLogo = JSON.parse(res?.data[0]?.logo);
//               setLogo(parseLogo?.img);
//             }
//           }
//         })
//         .catch((err) => {
//           if (err.response?.status === 401 || err.response?.status === 403) {
//             window.location.href = redirectUrl;
//           }
//           alert(err);
//         });
//     }

//     getStatusDatas();
//   }, []);

//   const totalQty = table.reduce((acc, cuu) => acc + cuu.qty, 0);

//   return (
//     <div style={{ padding: "12px" }}>
//       <div style={{ marginBottom: "10px" }}>
//         <Button variant="contained" onClick={handlePrint} autoFocus>Print</Button>
//         <Button style={{ marginLeft: "10px" }} onClick={() => navigate(-1)}>Back</Button>
//       </div>
//       <div
//         style={{
//           maxWidth: "700px",
//           backgroundColor: "white",
//           padding: "10px",
//           fontFamily: "sans-serif",
//         }}
//         ref={componentRef}
//       >
//         <div style={{ textAlign: "center" }}>
//           {logo && <img src={logo} width={90} alt="logo" />}
//           <h3>{company?.Name}</h3>
//           <p>{company?.Add1} {company?.Place}</p>
//           <p>{company?.Ph}</p>
//           <p>{company?.Web}</p>
//           <h3>{type || "INVOICE"}</h3>
//         </div>
//         <hr />
//         <div>
//           <p>Inv. No: {header?.billNo}</p>
//           <div style={{ display: "flex", justifyContent: "space-between" }}>
//             <p>Date: {header?.billDate}</p>
//             <p>Time: {header?.billTime}</p>
//           </div>
//         </div>
//         <hr />
//         <p>Name: {header?.party?.name || header?.party?.label}</p>
//         <div style={{ display: "flex", justifyContent: "space-between" }}>
//           <div style={{width:'100%'}}>
//             <p>Mobile: {header?.party?.phone}</p>
//             <p>Plan: {header?.party?.plan_name || ""}</p>
//           </div>
//           <div style={{width:'100%'}}>
//             {type === "QUOTATION" &&<p>Delivery Date: {header?.deliveryDate ? dayjs(header?.deliveryDate).format("DD/MM/YYYY") : ''}</p>}
//            {type !== "QUOTATION" && <p>Exp: {header?.party?.plan_end_date ? dayjs(header?.party?.plan_end_date).format("DD/MM/YYYY") : ''}</p>}

//             {type !== "QUOTATION" &&<p>Qty Left: {header?.party?.plan_items_left}</p>}
//           </div>
//         </div>
//         <hr />
//         <table style={{ width: "100%", textAlign: "center", fontSize: "12px" }}>
//           <thead>
//             <tr>
//               <th style={{ width: "5%" }}>SI</th>
//               <th style={{ width: "45%", textAlign: "left" }}>Item</th>
//               <th>Varient</th>
//               <th style={{ width: "5%" }}>Qty</th>
//               <th style={{ width: "20%" }}>Type</th>
//               {type !== "QUOTATION" && <th style={{ width: "15%" }}>Discount</th>}
//               {type !== "QUOTATION" && <th style={{ width: "15%" }}>Rate</th>}
//               {type !== "QUOTATION" && <th style={{ width: "15%" }}>Total</th>}
//             </tr>
//           </thead>
//           <tbody>
//             {table?.map((item, index) => (
//               <React.Fragment key={index}>
//                 <tr>
//                   <td>{index + 1}</td>
//                   <td colSpan={5} style={{ textAlign: "left" }}>{item.item}</td>

//                 </tr>
//                 <tr>
//                   <td style={{ width: "5%" }}></td>
//               <td style={{ width: "45%", textAlign: "left" }}></td>
//                   <td style={{ textAlign: "center" }}>{item.note}</td>
//                   <td >{item.qty}</td>
//                   <td>{item.type}</td>
//                   {type !== "QUOTATION" && <td>{item.Dis}</td>}
//                   {type !== "QUOTATION" && <td>{item.rate}</td>}
//                   {type !== "QUOTATION" && <td>{item.total}</td>}
//                 </tr>
//               </React.Fragment>
//             ))}
//           </tbody>
//         </table>
//         <hr />
//         {type !== "QUOTATION" ? (
//           <div>
//             <div style={{ textAlign: "right" }}>
//               <p>Subtotal: {header?.total?.toFixed(2)}</p>
//               <p>Disc Amount: {header?.discPercAmt?.toFixed(2) || header?.discAmt?.toFixed(2)}</p>
//               <p><strong>Net Amount: {header?.netTotal?.toFixed(2)}</strong></p>
//             </div>
//           </div>
//         ) : (
//           <div style={{ textAlign: "right" }}>
//             <p><strong>TOTAL QTY: {totalQty}</strong></p>
//           </div>
//         )}
//         <hr />
//         <p style={{ textAlign: "center", fontWeight: "bold" }}>Thank you, Visit again</p>
//       </div>
//     </div>
//   );
// };

// export default PrintOneThroughProps;
// PrintOneThroughProps.propTypes = {
//   state: PropTypes.any,
//   componentRef: PropTypes.any,
//   handlePrint: PropTypes.any

// };

// import React, { useEffect,  useState } from "react";

// import axios from "axios";
// import { commonUrl, redirectUrl } from "src/config";
// import {  useNavigate } from "react-router";
// import dayjs from "dayjs";
// import { Button } from "@mui/material";
// import PropTypes from "prop-types";

// const PrintOneThroughProps = ({state,componentRef,handlePrint}) => {
//   // const location = useLocation();
//   const navigate = useNavigate();
//   const [company, setCompany] = useState(null);
//   const [logo, setLogo] = useState(null);
//   const { header, table, type } = state || {};

//   useEffect(() => {
//     function getStatusDatas() {
//       axios
//         .get(commonUrl + "main/getCompanyDetails", { withCredentials: true })
//         .then((res) => {
//           if (res.data[0]) {
//             setCompany(res?.data[0]);
//             if (res?.data[0]?.logo) {
//               const parseLogo = JSON.parse(res?.data[0]?.logo);
//               setLogo(parseLogo?.img);
//             }
//           }
//         })
//         .catch((err) => {
//           if (err.response?.status === 401 || err.response?.status === 403) {
//             window.location.href = redirectUrl;
//           }
//           alert(err);
//         });
//     }

//     getStatusDatas();
//   }, []);

//   const totalQty = table.reduce((acc, cuu) => acc + cuu.qty, 0);

//   return (
//     <div style={{ padding: "12px" }}>
//       <div style={{ marginBottom: "10px" }}>
//         <Button variant="contained" onClick={handlePrint} autoFocus>Print</Button>
//         <Button style={{ marginLeft: "10px" }} onClick={() => navigate(-1)}>Back</Button>
//       </div>
//       <div
//         style={{
//           maxWidth: "700px",
//           backgroundColor: "white",
//           padding: "10px",
//           fontFamily: "sans-serif",
//         }}
//         ref={componentRef}
//       >
//         <div style={{ textAlign: "center" }}>
//           {logo && <img src={logo} width={90} alt="logo" />}
//           <h3>{company?.Name}</h3>
//           <p>{company?.Add1} {company?.Place}</p>
//           <p>{company?.Ph}</p>
//           <p>{company?.Web}</p>
//           <h3>{type || "INVOICE"}</h3>
//         </div>
//         <hr />
//         <div>
//           <p>Inv. No: {header?.billNo}</p>
//           <div style={{ display: "flex", justifyContent: "space-between" }}>
//             <p>Date: {header?.billDate}</p>
//             <p>Time: {header?.billTime}</p>
//           </div>
//         </div>
//         <hr />
//         <p>Name: {header?.party?.name || header?.party?.label}</p>
//         <div style={{ display: "flex", justifyContent: "space-between" }}>
//           <div style={{width:'100%'}}>
//             <p>Mobile: {header?.party?.phone}</p>
//             <p>Plan: {header?.party?.plan_name || ""}</p>
//           </div>
//           <div style={{width:'100%'}}>
//             {type === "QUOTATION" &&<p>Delivery Date: {header?.deliveryDate ? dayjs(header?.deliveryDate).format("DD/MM/YYYY") : ''}</p>}
//            {type !== "QUOTATION" && <p>Exp: {header?.party?.plan_end_date ? dayjs(header?.party?.plan_end_date).format("DD/MM/YYYY") : ''}</p>}

//             {type !== "QUOTATION" &&<p>Qty Left: {header?.party?.plan_items_left}</p>}
//           </div>
//         </div>
//         <hr />
//         <table style={{ width: "100%", textAlign: "center", fontSize: "12px" }}>
//           <thead>
//             <tr>
//               <th style={{ width: "5%" }}>SI</th>
//               <th style={{ width: "45%", textAlign: "left" }}>Item</th>
//               <th>Varient</th>
//               <th style={{ width: "5%" }}>Qty</th>
//               <th style={{ width: "20%" }}>Type</th>
//               {type !== "QUOTATION" && <th style={{ width: "15%" }}>Discount</th>}
//               {type !== "QUOTATION" && <th style={{ width: "15%" }}>Rate</th>}
//               {type !== "QUOTATION" && <th style={{ width: "15%" }}>Total</th>}
//             </tr>
//           </thead>
//           <tbody>
//             {table?.map((item, index) => (
//               <React.Fragment key={index}>
//                 <tr>
//                   <td>{index + 1}</td>
//                   <td colSpan={5} style={{ textAlign: "left" }}>{item.item}</td>

//                 </tr>
//                 <tr>
//                   <td style={{ width: "5%" }}></td>
//               <td style={{ width: "45%", textAlign: "left" }}></td>
//                   <td style={{ textAlign: "center" }}>{item.note}</td>
//                   <td >{item.qty}</td>
//                   <td>{item.type}</td>
//                   {type !== "QUOTATION" && <td>{item.Dis}</td>}
//                   {type !== "QUOTATION" && <td>{item.rate}</td>}
//                   {type !== "QUOTATION" && <td>{item.total}</td>}
//                 </tr>
//               </React.Fragment>
//             ))}
//           </tbody>
//         </table>
//         <hr />
//         {type !== "QUOTATION" ? (
//           <div>
//             <div style={{ textAlign: "right" }}>
//               <p>Subtotal: {header?.total?.toFixed(2)}</p>
//               <p>Disc Amount: {header?.discPercAmt?.toFixed(2) || header?.discAmt?.toFixed(2)}</p>
//               <p><strong>Net Amount: {header?.netTotal?.toFixed(2)}</strong></p>
//             </div>
//           </div>
//         ) : (
//           <div style={{ textAlign: "right" }}>
//             <p><strong>TOTAL QTY: {totalQty}</strong></p>
//           </div>
//         )}
//         <hr />
//         <p style={{ textAlign: "center", fontWeight: "bold" }}>Thank you, Visit again</p>
//       </div>
//     </div>
//   );
// };

// export default PrintOneThroughProps;
// PrintOneThroughProps.propTypes = {
//   state: PropTypes.any,
//   componentRef: PropTypes.any,
//   handlePrint: PropTypes.any

// };
